module.exports = __webpack_public_path__ + "img/pickup_stopped.f3c1ed07.svg";